import axios from 'axios';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as FaIcons from 'react-icons/fa';
import EditIcon from '../../images/edit-icon.svg';
import DeleteCategoryModal from './DeleteCategoryModal';
import EditCategoryModal from './EditCategoryModal';

const Categories = ({ categories, onDelete, showEdit }) => {
    const [modalInfo, setModalInfo] = useState([])

    const [rowData, setRowData] = useState([])

    const [editCategoryModal, setOpenEditCategoryModal] = useState(false)
    const handleEditCategoryModal = () => setOpenEditCategoryModal(!editCategoryModal)

    const [deleteCategoryModal, setOpenDeleteCategoryModal] = useState(false)
    const handleDeleteCategoryModal = () => setOpenDeleteCategoryModal(!deleteCategoryModal)

    const { REACT_APP_API_BACKEND_URL } = process.env;

    const rowEvents = {
        onClick: (e, row) => {
            
        }
    }

    // Edit Category
    const editCategory = async (category) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/infohub/editcategory';
        const categoryDetails = {
            categoryID: category.categoryID,
            categoryName: category.categoryName,
            categoryDesc: category.categoryDesc,
            modifiedBy: category.modifiedBy
        }

        axios.post(url, categoryDetails)
        .then(response => 
            alert('Folder has been successfully modified!'),
            setTimeout(()=>{
                setOpenEditCategoryModal(!editCategoryModal)
            }, 500),
            setTimeout(()=>{
                window.location.reload()
            }, 1000)
            
        )
        .catch(err => console.error(err));
    };

    function optionsFormatter(cell, row, rowIndex, formatExtraData) { 
        return (
            <img 
                src={EditIcon}
                className='table-icon'
                style={{minWidth: '60px', cursor: 'pointer'}} 
                onClick={() => {handleEditCategoryModal(); setModalInfo(row)}}
                alt=''
            />
        ); 
    } 

    const columns = [
        { dataField: 'categoryName', text: 'Folder Name', sort: true},
        { dataField: 'categoryDesc', text: 'Folder Description', sort: true},
        { dataField: "edit",
            text: "Options",
            hidden: showEdit ? false : true,
            formatter: optionsFormatter,
            headerAttrs: { width: 50 },
            attrs: { width: 50, className: "EditRow" } 
        }
    ]

    const selectRow = {
        mode: 'checkbox',
        nonSelectable: [0, 1, 2],
        onSelect: (row, isSelect, rowIndex, e) => {
            if (isSelect === true) {
                setRowData((rowData) => [...rowData, row.categoryID]);
            } else {
                setRowData((rowData) => rowData.filter((item) => item !== row.categoryID));
            }
        },
        onSelectAll: (isSelect, rows, e) => {
            if (isSelect === true) {
                setRowData(rows.map((item) => item.categoryID));
            } else 
                setRowData([]);
        }
    };

    const { SearchBar, ClearSearchButton } = Search;
    
    return (
        <ToolkitProvider
            keyField='categoryID'
            data={categories}
            columns={columns}
            search
        >
        {
            props => (
            <div style={{marginTop: '10px'}}>
                <SearchBar { ...props.searchProps } />
                <ClearSearchButton { ...props.searchProps } />
                {
                    rowData.length > 0 &&
                    <Button 
                        variant='outline-danger' 
                        onClick={() => {handleDeleteCategoryModal()}} 
                        style={{float:'right'}}>
                        <FaIcons.FaTrashAlt size={25} />
                    </Button>
                }
                <hr />
                {showEdit ?
                <BootstrapTable
                    { ...props.baseProps }
                    pagination={paginationFactory()}
                    rowEvents={rowEvents}
                    selectRow={selectRow}
                    noDataIndication='List is empty.'
                />
                :
                <BootstrapTable
                    { ...props.baseProps }
                    pagination={paginationFactory()}
                    rowEvents={rowEvents}
                    noDataIndication='List is empty.'
                />
                }
                <EditCategoryModal
                    show={editCategoryModal}
                    handleClose={handleEditCategoryModal}
                    modalInfo={modalInfo}
                    onEdit={editCategory}
                />
                <DeleteCategoryModal
                    show={deleteCategoryModal}
                    handleClose={handleDeleteCategoryModal}
                    rowData={rowData}
                    onDelete={onDelete}
                />
            </div>
            )
        }
        </ToolkitProvider>
    );
};

export default Categories;
